export default "__VITE_ASSET__ue3cVqzN__"